module.exports = __webpack_public_path__ + "static/logo-small-15bf417951b1a5df2c01be5cdd823bc7.png";